import { GetterTree } from 'vuex'

import { RootState } from '@/store/types'

import { PostcodeState } from './types'

const postcodeGetters: GetterTree<PostcodeState, RootState> = {
  mapData: state => state.mapData,

  postcode: (_, getters) => getters.mapData.postcode,

  getPostcodeData: state => (postcode: string) => state.postcodes[postcode],
}

export default postcodeGetters
